<template>
  <button
    type="button"
    :disabled="disabled"
    class="select-box"
    :class="{ active: selected, disabled: disabled }"
    @click="onClick"
    aria-label="select box"
  ></button>
</template>

<script>
export default {
  props: {
    color: String,
    disabled: Boolean,
    selected: [Boolean, Number],
    bubbleClicks: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(event) {
      if (!this.bubbleClicks) {
        event.stopPropagation()
      }
      this.$emit('action')
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../sass/base/_colors.scss' as *;
@use '../../sass/helpers/_mixins.scss' as *;

.select-box {
  @include eclipse(18px);
  background: white;
  border: 1px solid #4f4f4f;
  margin-top: -3px;
  margin-right: 4px;
  padding: 0;
  vertical-align: middle;
  transition: background-color 0.2s;

  &.active {
    background-color: var(--sub-color);
    border-color: var(--sub-color);
  }

  &.disabled {
    border-color: $main-disabled;
  }
}
</style>
